import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from "react-router-dom";

function ReOrderPopup({ isPopup, setIsPopup, onConfirm, onCancel, orderType }) {
    const location = useLocation();
    const navigate = useNavigate();
    const [popupActive, setPopupActive] = useState(false);

    useEffect(() => {
        const body = document.body;
        body.style.overflow = isPopup ? 'hidden' : 'auto';
        return () => {
            body.style.overflow = 'auto';
        };
    }, [isPopup]);

    useEffect(() => {
        let timeout;
        if (isPopup) {
            timeout = setTimeout(() => {
                setPopupActive(true);
            }, 100);
        } else {
            setPopupActive(false);
        }
        return () => clearTimeout(timeout);
    }, [isPopup]);

    useEffect(() => {
        document.body.style.overflow = 'auto';
    }, [location]);

    const handleClose = (e) => {
        e.preventDefault();
        setIsPopup(false);
    };

    // 딤 배경 클릭 핸들러 추가
    const handleBackgroundClick = (e) => {
        // popup-box-component 클래스를 가진 최상위 div를 클릭했을 때만 팝업 닫기
        if (e.target.className === 'popup-box-component') {
            setIsPopup(false);
        }
    };

    // orderType에 따라 다른 경로로 이동
    const handleCartView = () => {
        navigate(`/order/${orderType}`);
        setIsPopup(false); // 팝업 닫기
    };
    
    if (isPopup)
        return (
            <div 
                className="popup-box-component"
                onClick={handleBackgroundClick}
            >
                <div className={`box alert ${popupActive ? 'active' : ''}`}>
                    <div className="popup-content">
                        <div className="close_btn_con">
                            <button 
                            type="button" 
                            className="close_btn"
                            onClick={handleClose}
                            />
                        </div>
                        <i className='check_black'></i>
                        <p className='p3_1'>재주문 진행을 위해<br/> 장바구니에 상품을 담았습니다.</p>
                        <button 
                            type="button" 
                            className="confirm-btn"
                            onClick={handleCartView}
                        >
                            장바구니 보기
                        </button>
                    </div>
                </div>
            </div>
        );
}

export default ReOrderPopup;
